import React, { useState, useCallback, useEffect } from "react";
import "./GalleryPage.scss";
import { Slide } from "react-awesome-reveal";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/scrollbar";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Scrollbar } from "swiper";
// import { photos as photosList } from "./Photos";
import Gallery from "react-photo-gallery";
import Carousel, { Modal, ModalGateway } from "react-images";
import NotFound from "../NotFound/NotFound";
import serviceList from "../../utils/Services";
import { useSearchParams } from "react-router-dom";
import axios from "axios";
// import axios from "axios";

function GalleryPage() {
  const [currentImage, setCurrentImage] = useState(0);
  const [viewerIsOpen, setViewerIsOpen] = useState(false);
  const [serviceName, setServiceName] = useState(undefined);
  const [photos, setPhotos] = useState([]);
  const [photoTag, setPhotoTag] = useState(undefined);
  const [searchParams] = useSearchParams();
  const [apiMetaData, setApiMetaData] = useState({});
  // eslint-disable-next-line no-unused-vars
  const [isLoading, setIsLoading] = useState(false);
  const openLightbox = useCallback((event, { index }) => {
    setCurrentImage(index);
    setViewerIsOpen(true);
  }, []);

  const closeLightbox = () => {
    setCurrentImage(0);
    setViewerIsOpen(false);
  };

  useEffect(() => {
    let query = searchParams.get("items");
    if (query) {
      query = query.replaceAll("-", " ");
      query = query.split(" ");
      for (var i = 0; i < query.length; i++) {
        query[i] = query[i].charAt(0).toUpperCase() + query[i].slice(1);
      }
      query = query.join(" ");
      filterPhoto(query);
      fetchImages(query);
      setServiceName(query);
    } else {
      fetchImages("populate=*&pagination[page]=1");
    }
  }, []);

  const fetchImages = (params, pagination = false) => {
    setIsLoading(true);
    axios
      .get(`${process.env.REACT_APP_API_PATH}/galleries?${params}`)
      .then(function (response) {
        // handle success
        modifyTheApiResponse(response.data.data, pagination);
        setApiMetaData(response.data.meta);
      })
      .catch(function () {
        // handle error
        alert("something goes wrong");
      })
      .finally(function () {
        // always executed
        setIsLoading(false);
      });
  };

  const filterPhoto = (tag = "All") => {
    setPhotoTag(tag);
    setServiceName(tag);
    if (tag === "All") {
      setPhotoTag(undefined);
      // setPhotos(photosList);
      fetchImages("populate=*&pagination[page]=1");
    } else {
      fetchImages(`populate=*&filters[service_name]=${tag}&pagination[page]=1`);
    }
  };

  const modifyTheApiResponse = async (data, pagination) => {
    let PhotoListData = [];
    await data.forEach((item) => {
      PhotoListData.push({
        src: item.attributes.Image.data.attributes.url,
        width: item.attributes.Image.data.attributes.width,
        height: item.attributes.Image.data.attributes.height,
        tag: item.attributes.service_name,
      });
    });
    if (pagination) {
      setPhotos((prev) => [...prev, ...PhotoListData]);
    } else {
      setPhotos(PhotoListData);
    }
  };

  const handlePagination = (pageNumber) => {
    if (photoTag) {
      fetchImages(
        `populate=*&filters[service_name]=${photoTag}&pagination[page]=${pageNumber}`,
        true
      );
    } else {
      fetchImages(`populate=*&pagination[page]=${pageNumber}`, true);
    }
  };

  console.log(apiMetaData);
  return (
    <div className="gallery-wrap">
      <div className="container">
        <div className="heading ">
          <Slide direction="up">
            <h3>Galleries</h3>
          </Slide>
          <Slide direction="up">
            <h5>{serviceName}</h5>
          </Slide>
        </div>
        <div className="content">
          <div className="inner">
            <div className="g-tabs-wrap">
              <ul className="g-tabs">
                <Swiper
                  // install Swiper modules
                  modules={[Navigation, Scrollbar]}
                  loop={false}
                  slidesPerView={"auto"}
                  navigation={{
                    prevEl: ".swiper-button-prev",
                    nextEl: ".swiper-button-next",
                  }}
                  pagination={{ clickable: true }}
                  scrollbar={{ draggable: true }}
                  className="mySwiper"
                >
                  <SwiperSlide>
                    <li
                      className={`g-items ${photoTag ? "" : "active"}`}
                      onClick={() => {
                        filterPhoto("All");
                      }}
                    >
                      All
                    </li>
                  </SwiperSlide>

                  {serviceList?.map((item) => {
                    return (
                      <SwiperSlide key={item.id}>
                        <li
                          className={`g-items ${
                            photoTag === item.name ? "active" : ""
                          }`}
                          onClick={() => {
                            filterPhoto(item.tag);
                          }}
                        >
                          {item.name}
                        </li>
                      </SwiperSlide>
                    );
                  })}
                </Swiper>
                <div className="swiper-button-prev"></div>
                <div className="swiper-button-next"></div>
              </ul>
            </div>
            <div className="gallery-wrap spacing">
              {isLoading && (
                <div className="loading">
                  <div className="spinner2">
                    <div className="cube1"></div>
                    <div className="cube2"></div>
                  </div>
                </div>
              )}
              <div className="inner">
                {photos.length > 0 ? (
                  <>
                    <Gallery
                      photos={photos}
                      direction={"column"}
                      onClick={openLightbox}
                    />
                    <ModalGateway>
                      {viewerIsOpen ? (
                        <Modal onClose={closeLightbox}>
                          <Carousel
                            currentIndex={currentImage}
                            views={photos.map((x) => ({
                              ...x,
                              srcset: x.srcSet,
                              caption: x?.attributes?.service_name,
                            }))}
                          />
                        </Modal>
                      ) : null}
                    </ModalGateway>
                  </>
                ) : (
                  <NotFound />
                )}
              </div>
            </div>
            {apiMetaData?.pagination?.page !==
              apiMetaData?.pagination?.pageCount && (
              <div className="load-more-wrap">
                <Slide direction="up">
                  <button
                    onClick={() =>
                      handlePagination(apiMetaData?.pagination?.page + 1)
                    }
                    className="btn"
                  >
                    Load More
                  </button>
                </Slide>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default GalleryPage;
